module.exports = "7fcf23a039ac157916c63bc44f42eb06.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/shrine-top-l-4.png
// module id = 57
// module chunks = 0